// TEXT AMB NEGRETA I CURSIVA, escapat.
//
// Aquesta funció és **l'única cosa que hi ha entre una cadena i un `dangerouslySetInnerHTML`**.
// Fins al 27/08/2026 n'hi havia **tres còpies** —a `AjudaEtapa.js`, a `Arquetips.js` i a
// `EncaraNoABM.js`— i **ja havien divergit**: la primera també feia cursives i les altres dues no.
//
// La divergència d'aquell dia era inofensiva. La qüestió és que **la propera podia ser a la línia
// que escapa**, i ningú no se n'hauria adonat: el text que hi entra ve de les traduccions pròpies
// i cap prova hauria fallat. Aquest projecte ja ha pagat aquest patró dues vegades —les cinc
// còpies inline de `potVeure`, que van deixar el llistat de models obert, i la línia muda
// d'`updatedAt`, que hi era als tres llocs i no feia res.
//
// L'ordre importa: **primer s'escapa i després es marquen** la negreta i la cursiva. Al revés,
// les etiquetes que acabem de posar quedarien escapades i sortirien com a text.
//
// I una cosa que NO fa i no ha de fer: acceptar HTML de qui escriu. El `**` i el `*` són l'única
// manera de posar-hi marques, i qualsevol altra cosa surt tal qual.
export function textRic(text) {
  const escapat = String(text || '').replace(/[&<>"]/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  return escapat.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>');
}

export default textRic;
